module.exports = __webpack_public_path__ + "static/media/Laidley Street, San Francisco, CA7.39b20dec.jpg";